export default {
  BAR_CHART: 'BIỂU ĐỒ CỘT',
  BUBBLE_CHART: 'BIỂU ĐỒ PHÂN TÁN',
  LABEL_CHART_BOTTOM: 'KLGD Hôm Nay/ KLGDTB 5D',
  LABEL_CHART_LEFT: 'Tỷ Trọng (%)',
  LABEL_CHART_TOP: 'NHÓM ẢNH HƯỞNG MẠNH TỚI CHỈ SỐ',

  timeRange: {
    CONTRIB_1DAY: '1 NGÀY',
    CONTRIB_5DAY: '5 NGÀY',
    CONTRIB_10DAY: '10 NGÀY',
    CONTRIB_20DAY: '20 NGÀY',
  },
  CONTRIBUTION: 'Đóng Góp',
  MATCHED: 'Gía Khớp',
  VOLUME: 'Khối Lượng',
  VALUE: 'Gía Trị',
};
